import { PropsWithClassName } from 'lib-shared-types-utils';
import { memo, useMemo } from 'react';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { useChannelDashboardChannelContext } from '../../../../channelDashboardChannel.context';

import { ChannelDashboardAverageResponseTimeMetric } from './components/average/channelAverageResponseTimeMetric';
import { ChannelDashboardSLAResponseTimeMetric } from './components/sla/channelSlaResponseTimeMetric';

type ChannelDashboardResponseTimeMetricProps = PropsWithClassName;

export const ChannelDashboardResponseTimeMetric = memo(
  function ChannelDashboardResponseTimeMetric(
    props: ChannelDashboardResponseTimeMetricProps,
  ): JSX.Element {
    const flags = useFeatureFlag(['sla-management']);
    const { slaPolicies } = useChannelDashboardChannelContext();

    const slaPolicy = useMemo(
      () =>
        flags.slaManagement
          ? slaPolicies?.find((policy) =>
              policy.metrics.some(({ metric }) => metric === 'response_time'),
            )
          : undefined,
      [flags.slaManagement, slaPolicies],
    );

    return slaPolicy ? (
      <ChannelDashboardSLAResponseTimeMetric {...props} slaPolicy={slaPolicy} />
    ) : (
      <ChannelDashboardAverageResponseTimeMetric {...props} />
    );
  },
);
